import "react-app-polyfill/ie11";
import "./polyfill.js"; // tslint:disable-line

import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";

import App from "./App";
// import "./index.css";
// import registerServiceWorker from './registerServiceWorker';
import store from "./store";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root") as HTMLElement
);

// const script = document.createElement("script");
// script.type = "text/javascript";
// script.src =
//   "https://maps.googleapis.com/maps/api/js?key=AIzaSyAmnl2Bj-K2tMixcEr732vTe7ZtMVNy8Kw";
// document.getElementsByTagName("head")[0].appendChild(script);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx